import * as Yup from "yup";

const fileValidsTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
const problemInValid = ["site", "mobileApp", "windowsApp"];
const featureSectionValid = ["site", "mobileApp", "windowsApp"];
const ReportBugValidation = Yup.object().shape({
  problemIn: Yup.array().of(Yup.string().oneOf(problemInValid)),
  bug: Yup.string().required("نوشتن شرح مشکل الزامی است"),
  file: Yup.mixed()
    .test(
      "fileFormat",
      "یک عکس با فرمتهای jpg,png انتخاب شود",
      (value) => !value || fileValidsTypes.includes(value.type)
    )
    .test("fileSize", "حجم عکس نباید بیشتر از 2 مگابایت باشد", (file) => {
      return !file || file.size <= 2048000;
    }),
});

const NewRequestValidation = Yup.object().shape({
  featureSection: Yup.array().of(Yup.string().oneOf(featureSectionValid)),
  feature: Yup.string().required("نوشتن شرح پینشهاد الزامی است"),
  file: Yup.mixed()
    .test(
      "fileFormat",
      "یک عکس با فرمتهای jpg,png انتخاب شود",
      (value) => !value || fileValidsTypes.includes(value.type)
    )
    .test("fileSize", "حجم عکس نباید بیشتر از 2 مگابایت باشد", (file) => {
      return !file || file.size <= 2048000;
    }),
});

const subjectsValid = ["support", "technical", "financial", "other"];

const createTicketValidation = Yup.object().shape({
  subject: Yup.string().oneOf(subjectsValid),
  title: Yup.string().required("نوشتن عنوان الزامی است"),
  ticketContent: Yup.string().required("نوشتن پیام الزامی است"),
  file: Yup.mixed()
    .test(
      "fileFormat",
      "یک عکس با فرمتهای jpg,png انتخاب شود",
      (value) => !value || fileValidsTypes.includes(value.type)
    )
    .test("fileSize", "حجم عکس نباید بیشتر از 2 مگابایت باشد", (file) => {
      return !file || file.size <= 2048000;
    }),
});

export { ReportBugValidation, NewRequestValidation, createTicketValidation };
